/** Shared neutral styling for runtime fallbacks (error UI, not Phase 9 components). */
import type { CSSProperties } from 'react'

export const fallbackStyle: CSSProperties = {
  padding: '1rem',
  margin: '0.5rem 0',
  border: '1px dashed #cbd5e1',
  borderRadius: '8px',
  color: '#64748b',
  fontFamily: 'system-ui, sans-serif',
  fontSize: '0.875rem',
  textAlign: 'center',
}
